import api, { URLS } from "@/services/api.js";

const BASE_URL = `${URLS.API_FGTAS}/empresas`;

export const listarEmpresasDoUsuario = () => api.get(`${BASE_URL}/listar-empresas-do-usuario`);

export const carregar = (cnpj) => api.get(`${BASE_URL}/${cnpj}`);

export const carregarAdmin = (cnpj) => api.get(`${BASE_URL}/admin/${cnpj}`);

export const vincular = (cnpj) => api.put(`${BASE_URL}/vincular/${cnpj}`);

export const buscarDisponivelCadastro = (cnpj) => api.get(`${BASE_URL}/buscar-disponivel-cadastro/${cnpj}`);

export const desvincular = (id) => api.delete(`${BASE_URL}/desvincular/${id}`);

export const salvar = (cnpj) => api.post(`${BASE_URL}/${cnpj}`);

export const listarTodasEmpresasAdmin = (params, filtros) => {
	return api.post(`${BASE_URL}/admin/listar`, filtros, params);
};
